// Support channel — one source of truth for the support address and mailto links.

export const SUPPORT_EMAIL = "support@ahcut.com";

export function supportMailto(subject: string): string {
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
}
